import React, { useContext } from 'react';
import PriceField from './price_field';
import PricePerUnit from './price_per_unit';
import VolumeRange from './volume_range';
import { ProductContext } from '../contexts/product_context';

function PricingOptions({ activeSchema }) {
  const { priceRangeErrors } = useContext(ProductContext);
  return (
    <>
      { activeSchema === 'flat' && <PriceField /> }
      { activeSchema === 'per_unit' && <PricePerUnit /> }
      {['step_usage', 'volume_usage', 'tier_usage'].includes(activeSchema) && <VolumeRange type={activeSchema} priceRangeErrors={priceRangeErrors} />}
    </>
  );
}
export default PricingOptions;
